import {WelcomeVo} from '../../common/shared/api/gateway/welcome/WelcomeVo.interface';
import {Welcome} from '../generated/types';
import {createWelcomeInfo} from './WelcomeInfo';
import {createWelcomeRecommendItem} from './WelcomeRecommendItem';

export function createWelcome({
  welcome_info,
  recommend_contents,
}: WelcomeVo): Welcome {
  return {
    welcomeInfo: welcome_info && createWelcomeInfo(welcome_info),
    recommendContents: {
      webtoonList: recommend_contents.webtoon.map(createWelcomeRecommendItem),
      novelList: recommend_contents.novel.map(createWelcomeRecommendItem),
    },
  };
}
